import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Checkbox, InputNumber, Radio } from "antd";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import {
  DETAIL_ACTIONS,
  CAMPAIGN as CAMPAIGN_ENUM
} from "../../../../../../constants/Define";
import GuestEmails from "../GuestEmails";
import { capitalizeFirstLetter } from "../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import { toArray, isEqual } from "lodash";

const CheckboxGroup = Checkbox.Group;

const defaultCollapseKey = "campaignUseObject";

function UseObjectSection(props) {
  const {
    campaign,
    validation,
    action,
    onChange,
    setCampaign,
    renderInfoTooltip,
    createType
  } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  const onChangeMemberShip = list => {
    const getSelectedValue = item => item.value;
    const allOptions = getMemberShipTypeEnums().map(getSelectedValue);
    const memberShipTypes = isEqual(allOptions, list)
      ? getMemberShipTypeEnums(true).map(getSelectedValue)
      : list;
    campaign.memberShipTypes = memberShipTypes
    setCampaign(campaign);
  };

  const onChangeLimitNumber = (fieldName, value) => {
    onChange(
      fieldName,
      value === null || value === undefined || value === "" ? undefined : value
    );
  };

  const getMemberShipTypeEnums = () => {
    return toArray(CAMPAIGN_ENUM.MEMBER_SHIP_TYPE);
  };

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  const showUserLimitConfig =
    campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.MEMBER.id ||
    campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.ANOTHER.id;

  const showMaxRoomNightPerUser =
    showUserLimitConfig && createType === CAMPAIGN_ENUM.CREATE_TYPE.HOTEL;

  useEffect(() => {
    const hasError = validation && (validation.objectType)
    if (hasError && !collapseKey) {
      setCollapseKey(defaultCollapseKey);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validation])

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.useObjectHeader")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent
              isValidation={true}
              labelTitle={capitalizeFirstLetter(
                (
                  t("action.select") +
                  " " +
                  t("item.campaign.useObjectHeader")
                ).toLowerCase()
              )}
              validation={validation.objectType}
              messageBelowInput={true}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Wrapper>
                <Radio.Group
                  value={campaign.objectType}
                  onChange={e => onChange("objectType", e.target.value)}
                  disabled={!campaign.canEdit}
                >
                  {toArray(CAMPAIGN_ENUM.OBJECT_TYPE).map(item =>
                    renderInfoTooltip(
                      t(`item.campaign.objectType.description.${item.key}`),
                      <Radio
                        key={item.key}
                        value={item.id}
                        className="mr-0"
                        disabled={
                          (createType === CAMPAIGN_ENUM.CREATE_TYPE.DIEM && item.id === 'MEMBER') ||
                          (createType === CAMPAIGN_ENUM.CREATE_TYPE.DIEM && item.id === 'ANOTHER')
                        }
                      >
                        {t(`item.campaign.objectType.${item.key}`)}
                      </Radio>,
                      "mr-3"
                    )
                  )}
                </Radio.Group>
              </Wrapper>
            </FormWrapperInputComponent>
          </Wrapper>
          {campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.MEMBER.id && (
            <Wrapper className="col-md-12" style={{marginBottom: "12px"}}>
              <CheckboxGroup
                className="m-t"
                options={getMemberShipTypeEnums()}
                value={
                  campaign.memberShipTypes.length > 0 &&
                  campaign.memberShipTypes.map(item =>
                    typeof item === "string"
                      ? CAMPAIGN_ENUM.MEMBER_SHIP_TYPE[item]?.value
                      : item
                  )
                }
                onChange={onChangeMemberShip}
                disabled={action === DETAIL_ACTIONS.TRANSLATE}
              />
            </Wrapper>
          )}
          {campaign.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.ANOTHER.id && (
            <Wrapper className="col-md-6">
              <FormWrapperInputComponent
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <GuestEmails
                  onChange={onChange}
                  lstEmails={campaign.emails}
                  lstEmailSuffix={campaign.emailSuffix}
                  canEdit={campaign.canEdit}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                />
              </FormWrapperInputComponent>
            </Wrapper>
          )}
          {showUserLimitConfig && (
            <Wrapper className="col-md-12">
              <FormWrapperInputComponent
                isValidation={true}
                labelTitle={t("item.campaign.userFrequencyLimitCount")}
                dataValidation={campaign.userFrequencyLimitCount}
                validation={validation.userFrequencyLimitCount}
                messageBelowInput={true}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Wrapper>
                  <InputNumber
                    min={1}
                    step={1}
                    precision={0}
                    name="userFrequencyLimitCount"
                    className="userFrequencyLimitCount"
                    value={campaign.userFrequencyLimitCount}
                    onChange={value =>
                      onChangeLimitNumber("userFrequencyLimitCount", value)
                    }
                    disabled={!campaign.canEdit}
                  />
                </Wrapper>
              </FormWrapperInputComponent>
            </Wrapper>
          )}
          {showUserLimitConfig && (
            <Wrapper className="col-md-12">
              <FormWrapperInputComponent
                labelTitle={t("item.campaign.userFrequencyLimitPeriodTitle")}
                isValidation={true}
                dataValidation={campaign.userFrequencyLimitPeriod}
                validation={validation.userFrequencyLimitPeriod}
                messageBelowInput={true}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Wrapper>
                  <Radio.Group
                    value={campaign.userFrequencyLimitPeriod}
                    onChange={e =>
                      onChange("userFrequencyLimitPeriod", e.target.value)
                    }
                    disabled={!campaign.canEdit}
                  >
                    {toArray(CAMPAIGN_ENUM.USER_FREQUENCY_LIMIT_PERIOD).map(
                      item => (
                        <Radio key={item.key} value={item.id} className="mr-3">
                          {t(
                            `item.campaign.userFrequencyLimitPeriod.${item.key}`
                          )}
                        </Radio>
                      )
                    )}
                  </Radio.Group>
                </Wrapper>
              </FormWrapperInputComponent>
            </Wrapper>
          )}
          {showMaxRoomNightPerUser && (
            <Wrapper className="col-md-12">
              <FormWrapperInputComponent
                isValidation={true}
                labelTitle={t("item.campaign.maxRoomNightPerUser")}
                dataValidation={campaign.maxRoomNightPerUser}
                validation={validation.maxRoomNightPerUser}
                messageBelowInput={true}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Wrapper>
                  <InputNumber
                    min={1}
                    step={1}
                    precision={0}
                    name="maxRoomNightPerUser"
                    className="maxRoomNightPerUser"
                    value={campaign.maxRoomNightPerUser}
                    onChange={value =>
                      onChangeLimitNumber("maxRoomNightPerUser", value)
                    }
                    disabled={!campaign.canEdit}
                  />
                </Wrapper>
              </FormWrapperInputComponent>
            </Wrapper>
          )}
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

UseObjectSection.propTypes = {
  campaign: PropTypes.object,
  validation: PropTypes.object,
  action: PropTypes.string,
  onChange: PropTypes.func,
  setCampaign: PropTypes.func,
  renderInfoTooltip: PropTypes.func,
  createType: PropTypes.object
};

UseObjectSection.defaultProps = {
  campaign: {},
  validation: {},
  action: "",
  onChange: () => {},
  setCampaign: () => {},
  renderInfoTooltip: () => {}
};

export default UseObjectSection;
